import React, { useEffect, useState } from 'react';
import Header from '../../../Components/Header';
import Footer from '../../../Components/Footer';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ApiService } from '../../../Components/Services/apiServices';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { FaHeart, FaLocationArrow, FaStar } from 'react-icons/fa';
import Category from '../Category';
import Skeleton from 'react-loading-skeleton';
import { useWishlist } from '../../../Components/Context/WishlistContext';

const IMAGE_BASE_URL = "https://www.adminfamilyfun.jewelscraze.com/front/images/rooms/";

const SearchResult = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [userLocation, setUserLocation] = useState(null);
    const [hovered, setHovered] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const searchQuery = queryParams.get("search") || "";
    const [loading, setLoading] = useState(false);

    const categoryParam = queryParams.get("category");
    const [category, setCategory] = useState([]);

    const [searchResults, setSearchResults] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(categoryParam);
    const { wishlist, toggleWishlistItem, handleRemoveFromWishlist } = useWishlist();

    useEffect(() => {
        // If URL has ?category, sync it to selectedCategory on mount
        if (categoryParam && categoryParam !== selectedCategory) {
            setSelectedCategory(categoryParam);
        }
    }, [categoryParam]);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (searchQuery.trim() !== "") {
                fetchFilteredResults(searchQuery, selectedCategory);
            } else {
                setSearchResults([]);
            }
        }, 300);

        return () => clearTimeout(delayDebounce);
    }, [searchQuery, selectedCategory]);

    const fetchFilteredResults = async (search, categoryUrl) => {
        let endpoint = `search?query=${search}`;
        if (categoryUrl) {
            endpoint += `&category=${categoryUrl}`;
        }

        try {
            const res = await ApiService.Commanfetchrequest(endpoint);
            setSearchResults(res);
        } catch (error) {
            console.log("Error fetching filtered results:", error);
        }
    };


    useEffect(() => {
        const fetchtcategory = async () => {
            try {
                setLoading(true);
                const categoryData = await ApiService.Commanfetchrequest('categories');
                setCategory(categoryData);
                // console.log('category data:', categoryData);
            } catch (error) {
                console.log('error while fetching:', error);
            } finally {
                setLoading(false);
            }
        };

        const getUserLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        setUserLocation({ latitude, longitude });
                    },
                    (error) => {
                        console.error("Geolocation error:", error);
                    }
                );
            } else {
                console.warn("Geolocation not supported.");
            }
        };

        fetchtcategory();
        getUserLocation();
    }, []);

    const handleCategorySelect = (catUrl) => {
        setSelectedCategory(catUrl);

        // Update URL query params
        const updatedParams = new URLSearchParams(location.search);
        if (catUrl) {
            updatedParams.set("category", catUrl);
        } else {
            updatedParams.delete("category");
        }

        // Ensure the URL is updated and the component re-renders
        navigate(`${location.pathname}?${updatedParams.toString()}`, { replace: true });
    };

    const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
        const R = 6371;
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return d;
    };

    return (
        <>
            <Header />
            <div className="category-container">
                {loading
                    ? Array.from({ length: 10 }).map((_, index) => (
                        <div key={index} className="category-item">
                            <Skeleton
                                circle={true}
                                width={40}
                                height={40}
                                style={{ marginBottom: '10px' }}
                            />
                            <span><Skeleton width={80} height={20} /></span>
                        </div>
                    ))
                    : category.map((cat, index) => (
                        <div key={index} onClick={() => handleCategorySelect(cat.category_name)} style={{ textDecoration: "none" }}>
                            <div className="category-item">
                                {cat.category_image && (
                                    <img
                                        src={`https://www.adminfamilyfun.jewelscraze.com/front/images/categories/${cat.category_image}`}
                                        alt={cat.category_name}
                                        className="category-image"
                                        style={{ width: "30px", height: "30px" }}
                                        loading="lazy"
                                    />
                                )}
                                <br />
                                <span>{cat.category_name}</span>
                            </div>
                        </div>
                    ))}
            </div>

            <div className='text-center'>
                {searchQuery && (
                    <p style={{ padding: "10px" }}>
                        <span style={{ marginRight: "10px", fontWeight: "600" }}>{searchResults?.length}</span>
                        Results found for "<strong>{searchQuery}</strong>"
                        {selectedCategory && <> in category "<strong>{selectedCategory}</strong>"</>}
                    </p>
                )}
            </div>

            <div className="container listings-container">
                {searchResults.map((property, index) => (
                    <div key={index} className="listing-card">
                        <div className="image-container">
                            <Link to={`/property-details/${property.room_name}`}>
                                <Swiper
                                    modules={[Pagination]}
                                    spaceBetween={10}
                                    slidesPerView={1}
                                    pagination={{ clickable: true }}
                                >
                                    {Array.isArray(property.room_images) && property.room_images.length > 0 ? (
                                        property.room_images.map((img, i) => (
                                            <SwiperSlide key={i}>
                                                <img
                                                    src={`${IMAGE_BASE_URL}${img.room_images}`}
                                                    alt={`${property.room_name} - ${i}`}
                                                    className="listing-image"
                                                />
                                            </SwiperSlide>
                                        ))
                                    ) : (
                                        <SwiperSlide>
                                            <img
                                                src="/images/default-property.jpg"
                                                alt="Default"
                                                className="listing-image"
                                            />
                                        </SwiperSlide>
                                    )}
                                </Swiper>

                            </Link>
                            <div
                                className="wishlist-icon"
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    zIndex: 10,
                                    cursor: "pointer",
                                    transition: "transform 0.2s ease",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                onClick={() => toggleWishlistItem(property)}
                            >
                                <FaHeart style={{
                                    color: wishlist.some((item) => item.room_name === property.room_name)
                                        ? "red"
                                        : "white", fontSize: "1.5rem"
                                }} />
                            </div>
                        </div>
                        <div className="listing-info">
                            <h3>{property.room_name}</h3>
                            <p>{property.location}</p>
                            {userLocation && property.latitude && property.longitude ? (
                                <>
                                    <FaLocationArrow className="star-icon" style={{ color: "red" }} />
                                    <a
                                        href={`https://www.google.com/maps/dir/?api=1&origin=${userLocation.latitude},${userLocation.longitude}&destination=${property.latitude},${property.longitude}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            textDecoration: 'none',
                                            color: hovered ? 'blue' : '#000',
                                            marginLeft: '5px',
                                            transition: 'color 0.2s ease',
                                        }}
                                        onMouseEnter={() => setHovered(true)}
                                        onMouseLeave={() => setHovered(false)}
                                    >
                                        {(() => {
                                            const distanceKm = getDistanceFromLatLonInKm(
                                                userLocation.latitude,
                                                userLocation.longitude,
                                                parseFloat(property.latitude),
                                                parseFloat(property.longitude)
                                            );
                                            return distanceKm < 1
                                                ? `${Math.round(distanceKm * 1000)} m away`
                                                : `${distanceKm.toFixed(1)} km away`;
                                        })()}
                                    </a>
                                </>
                            ) : (
                                <FaLocationArrow className="star-icon" style={{ color: "gray" }} />
                            )}
                            <p><FaStar className="star-icon" /> 4.9</p>
                        </div>
                    </div>
                ))}
            </div>

            <Footer />
        </>
    );
};

export default SearchResult;
